module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/1/4-a781bb19234570d6a58953e2c78567cf.jpg";